"use client";
import React, { useMemo } from "react";
import { useAtom } from "jotai";
import { latestViewedProductsAtom } from "@/hooks/productAtoms";
import { useCacheInvalidation } from "@/hooks/useCacheInvalidation";
import ProductGrid from "./ProductGrid";
import { IProducts } from "@/api/AppApi/services/home/interfaces/IProduct";
import { ITheme } from "@/api/AppApi/services/company/interfaces/ICompany";
import { processProductsData } from "../common/functions";

interface Props {
  products: IProducts;
  setIslastProduct?: (isLastProduct: boolean) => void;
  scrollableTabs?: boolean;
  theme: ITheme;
  showCustomEventData?: boolean;
  /** Server-generated shuffle seed — keeps the random order identical across SSR and hydration. */
  shuffleSeed?: number;
}

const ProductGridWrapper: React.FC<Props> = (props) => {
  useCacheInvalidation();
  const [latestViewed] = useAtom(latestViewedProductsAtom);
  const { products, shuffleSeed } = props;

  const mergedProducts = useMemo(() => {
    const backendDataLength = Array.isArray(products?.data) ? products.data.length : 0;
    return processProductsData(products, latestViewed, backendDataLength, shuffleSeed);
  }, [products, latestViewed, shuffleSeed]);

  return <ProductGrid {...props} products={mergedProducts} />;
};

export default ProductGridWrapper;
